class WelchSeasonalNotice extends HTMLElement {
  async connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();
    const controller=this.controller;
    try{
      const url=(window.Shopify?.routes?.root||'/')+'apps/welch-delivery?'+new URLSearchParams({seasonal:'1',products:this.dataset.productId});
      const response=await fetch(url,{cache:'no-store',signal:AbortSignal.any([controller.signal,AbortSignal.timeout(15000)])});
      if(!response.ok)throw new Error('Unavailable');
      const {window:delivery}=await response.json();if(!this.isConnected||controller.signal.aborted)return;
      this.hidden=!delivery;this.style.display=delivery?'block':'none';
      if(delivery){this.style.display='block';this.style.marginBlock='1rem';this.textContent=delivery.blocked?'This product has no available seasonal delivery window. Please contact the shop.':`Available for delivery ${delivery.from.split('-').reverse().join('/')}–${delivery.to.split('-').reverse().join('/')}. Available days depend on your postcode and delivery service.`;}
    }catch{if(this.isConnected&&!controller.signal.aborted){this.hidden=false;this.style.display='block';this.textContent='Delivery availability will be checked in your basket.';}}
  }
  disconnectedCallback(){this.controller?.abort();}
}
if(!customElements.get('welch-seasonal-notice'))customElements.define('welch-seasonal-notice',WelchSeasonalNotice);
